module.exports = __webpack_public_path__ + "assets/edit-circle.4eed90e1.svg";